import React from 'react';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip from Material-UI

function PresetScenarios({ scenarios, handlePresetScenario }) {
  return (
    <div className="container" style={{ marginTop: '20px' }}>
      {scenarios.map((scenario, index) => (
        <Tooltip key={index} title={scenario.tooltip} arrow> {/* Wrap the button with Tooltip */}
          <button
            className="preset-button"
            onClick={() => handlePresetScenario(scenario)}
          >
            {scenario.label}
          </button>
        </Tooltip>
      ))}
    </div>
  );
}

export default PresetScenarios;
